import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  deleteInvoicesAction,
  updateInvoicesAction,
} from 'src/store/payments/actions';

const invoiceHandler = (event: string, items: Array<any>) => {
  if (items.length === 0) {
    return null;
  }
  switch (event) {
    case EVENTS.REMOVE:
      return deleteInvoicesAction(items);
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return updateInvoicesAction(items);
    default:
      break;
  }
  return null;
};

export default invoiceHandler;
